import { useBreadcrumbs } from '@hypeit-gmbh/hypeit-ui-core';
import { Anchor, Breadcrumbs as MantineBreadcrumbs } from '@mantine/core';
import { Link } from '@tanstack/react-router';

export const BreadCrumbs: React.FC = () => {
  const { breadcrumbs } = useBreadcrumbs();

  return (
    <MantineBreadcrumbs>
      {breadcrumbs.map((breadcrumb) => (
        <Anchor
          component={Link}
          key={`breadcrumb-${breadcrumb.crumb}`}
          to={breadcrumb.to}
        >
          {breadcrumb.crumb}
        </Anchor>
      ))}
    </MantineBreadcrumbs>
  );
};
